import React from 'react';
import ReminderCard from './ReminderCard';
import EmptyState from './EmptyState';
import { areRemindersEmpty } from '../utils/reminderUtils';

const ReminderList = ({
  filteredReminders,
  onEdit,
  onDelete,
  onActiveChange,
}) => {
  const isEmpty = areRemindersEmpty(filteredReminders);

  if (isEmpty) {
    return <EmptyState />;
  }

  return (
    <>
      {filteredReminders?.map(
        (reminder) =>
          reminder?.reminders?.length > 0 &&
          reminder?.reminders?.map((data) => (
            <ReminderCard
              key={`${reminder?.patientId}-${data.id}`}
              reminder={reminder}
              data={data}
              onEdit={onEdit}
              onDelete={onDelete}
              onActiveChange={onActiveChange}
            />
          ))
      )}
    </>
  );
};

export default ReminderList;
